/**
 * src/modules/perfil-tribuna.js
 *
 * Vista "Mi historial tribunero" del perfil (Scoring Ritualístico v1.0
 * §11 / R9). Muestra 3 contadores agregados de reacciones EMITIDAS por
 * el jugador a rituales de otros, sin feed, sin timeline, sin badges.
 *
 * Auditoría scoring ritualístico (29-may): los contadores eran hardcoded
 * a 0; ahora se leen de reacciones_ritual vía contarReaccionesEmitidas
 * (core/rituales.js) y se pintan async. Mientras carga, se muestran "—".
 *
 * Disparada por:
 *   - Click en el botón "Reacciones tribuneras" de perfil.js: navega a
 *     hash /perfil-tribuna/<codigo>.
 *   - router.js maneja esa ruta directamente post-3.16.
 */

import { activeGroupBarPM, bottomNavPM, formatPM } from './perfil-helpers.js';
import { getCurrentUser } from '../core/auth.js';
import { contarReaccionesEmitidas } from '../core/rituales.js';

export const renderPerfilTribuna = async (codigo) => {
    const root = document.getElementById('app-root');
    if (!root) return;
    // DT-EP cerrada (29-may): el historial cuenta reacciones de TODOS los
    // player_id del user (todos los grupos del usuario), simétrico al
    // Ranking Nacional v1.2 §4.2. La ruta es contextual al grupo activo
    // solo para la barra y el back; los contadores son del USUARIO.
    const currentUser = getCurrentUser();
    root.innerHTML = `
        <div class="perfil-v2">
            ${activeGroupBarPM(codigo)}
            <header class="perfil-prode-head">
                <button class="perfil-back" type="button" data-reactions-back>Volver</button>
                <div>
                    <h2 class="perfil-prode-title">Mi historial tribunero</h2>
                    <p class="perfil-prode-sub">Participaci&oacute;n y presencia en la tribuna</p>
                </div>
            </header>
            <section>
                <article class="tribuna-reactions-card">
                    <span>Reacciones a arengas</span>
                    <strong data-cnt="arenga">—</strong>
                </article>
                <article class="tribuna-reactions-card">
                    <span>Reacciones cabuleras</span>
                    <strong data-cnt="cabala">—</strong>
                </article>
                <article class="tribuna-reactions-card">
                    <span>Reacciones a promesas</span>
                    <strong data-cnt="promesa">—</strong>
                </article>
            </section>
        </div>
        ${bottomNavPM(codigo)}
    `;
    root.querySelector('[data-reactions-back]')?.addEventListener('click', () => {
        window.location.hash = `/perfil/${codigo}`;
    });

    // Hidratar contadores reales (async). Si no hay sesión, queda en 0.
    const counts = await contarReaccionesEmitidas(currentUser?.user_id);
    const slotA = root.querySelector('[data-cnt="arenga"]');
    const slotC = root.querySelector('[data-cnt="cabala"]');
    const slotP = root.querySelector('[data-cnt="promesa"]');
    if (slotA) slotA.textContent = formatPM(counts.arenga);
    if (slotC) slotC.textContent = formatPM(counts.cabala);
    if (slotP) slotP.textContent = formatPM(counts.promesa);
};
